/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zalo_UnavailableInputs */

const vi_error_zalo_unavailable = /** @type {(inputs: Error_Zalo_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không liên lạc được với Zalo. Vui lòng thử lại sau ít phút.`)
};

/**

* @param {Error_Zalo_UnavailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zalo_unavailable = /** @type {((inputs?: Error_Zalo_UnavailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zalo_UnavailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zalo_unavailable(inputs)
});